import React from 'react';

/**
 * PaginationButton Atom Component
 * Individual page number button for pagination
 */
const PaginationButton = ({ 
  page,
  isActive = false,
  isDisabled = false,
  onClick,
  children,
  className = '',
  ...props 
}) => {
  const baseClasses = 'px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200';
  const activeClasses = isActive
    ? 'bg-blue-600 text-white'
    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300';
  const disabledClasses = isDisabled
    ? 'opacity-50 cursor-not-allowed'
    : 'cursor-pointer';

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`${baseClasses} ${activeClasses} ${disabledClasses} ${className}`}
      {...props}
    >
      {children || page}
    </button>
  );
};

export default PaginationButton;

